<div class="item-grid cgap-10 rgap-10 py-5" [@listAnim]="total()">
  @for(item of items(); track item[item_track_key()] || item){
    <ng-container *ngTemplateOutlet="item_template(); context: { $implicit: item, index: $index, first: $first, last: $last }"></ng-container>
    
  }
</div>
@if(!loading() && items().length){
  <div class="tester" inViewport (inViewportAction)="viewportTrigger($event)" [inViewportOptions]="{ threshold: [0] }"></div>
}
@if(!isFinal() || loading()){
  <div class="svg-loader f-main-center f-cross-center">
    <object data="/old/cloudigo_loader.svg" type="image/svg+xml"></object>
  </div>
} @else if(!items().length){
  <h3 class="w-full text-center">No {{item_name().toLowerCase()}} found</h3>
}